import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            I'm <span className="purple">Prateek Kumar Sharma</span>, an AI Software Engineer and Master's student based in Kaiserslautern, Germany.
            <br />
            <br />
            <span className="purple">📌 Current Status:</span> Pursuing my Master's in Computer Science (Software Engineering & Intelligent Systems) at RPTU Kaiserslautern while working part-time as an AI Software Engineer at Fraunhofer IESE on the DEUTSCHLAND.DIGITAL project, focusing on automated software quality evaluation workflows.
            <br />
            <br />
            <span className="purple">💡 Expertise:</span> I work across the full stack, from frontend interfaces to backend services, and specialize in applying AI/ML and data science to real products. My recent work includes LLM and AI agent-driven workflows, along with projects in autonomous driving and software quality evaluation.
            <br />
            <br />
            <span className="purple">🧭 Background:</span> My journey across DFKI, Ferns N Petals, and Fraunhofer IESE combines research depth with product execution, from experimentation and model development to production-ready software delivery.
            <br />
            <br />
            <ImPointRight/> What drives me:
          </p>
          <ul>
            <li className="about-activity">
              ⚡ Experimenting with cutting-edge AI/ML and building proof-of-concept solutions.
            </li>
            <li className="about-activity">
              ✍️ Writing technical blogs and sharing insights on AI, web development, and innovation.
            </li>
            <li className="about-activity">
              🌍 Traveling, photography, and exploring diverse cultures.
            </li>
            <li className="about-activity">
              📚 Reading about AI advancements, technology trends, and global innovations.
            </li>
            <li className="about-activity">
              🏏 Playing Cricket & 🏸 Badminton to stay energized.
            </li>
            <li className="about-activity">
              🎧 Listening to music—my creative fuel.
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Passionate about building things that matter, simple, impactful, and future-ready." 🚀
          </p>
          <footer className="blockquote-footer">Prateek Kumar Sharma</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
